/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import withPageTracking from 'shared/analytics/components/withPageTracking';
import {
    Column,
    Container,
    Divider,
    ErrorBoundary,
    Header,
    Footer,
    NotFoundError,
    Row,
    Sidebar,
    Spacer,
    UserContext,
    ModalContext
} from 'school-space-client/components';

import UpcomingBookingsScreen from './screens/UpcomingBookings';
import ReserveASpaceScreen from './screens/ReserveASpace';

const navLinks = [
    {
        title: 'Contact us',
        url: 'https://school-space.org/about-us/contact-us',
        isExternal: true
    }
];

const sidebarLinks = [
    {
        title: 'Upcoming bookings',
        url: '/'
    },
    {
        title: 'Reserve a space',
        url: '/reserve-a-space'
    },
    {
        title: 'Logout',
        url: '/logout'
    }
];

const css = {
    wrapper: () => ({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    }),
    sidebar: theme => ({
        display: 'none',
        [theme.helpers.mq('l')]: {
            display: 'block'
        }
    }),
    contentWrapper: () => ({
        flexGrow: '1'
    }),
    content: theme => ({
        [theme.helpers.mq('l')]: { paddingLeft: theme.grid.gutter.l }
    })
};

const Dashboard = () => {
    const user = useContext(UserContext);
    const {
        openModal,
        types: { mobileMenu }
    } = useContext(ModalContext);

    return (
        <div css={css.wrapper}>
            <Header
                links={navLinks}
                openMenu={() =>
                    openModal({
                        type: mobileMenu,
                        props: {
                            links: [...navLinks, ...sidebarLinks]
                        }
                    })
                }
            />
            <Divider />
            <Container styles={css.contentWrapper}>
                <Spacer height={2.5} />
                <Row verticalAlign="flex-start">
                    <Column styles={css.sidebar} l={[3]}>
                        <Sidebar user={user} links={sidebarLinks} />
                    </Column>
                    <Column styles={css.content} s={[6]} m={[12]} l={[9]}>
                        <ErrorBoundary>
                            <Switch>
                                <Route
                                    exact
                                    path="/upcoming-bookings"
                                    component={UpcomingBookingsScreen}
                                />
                                <Route
                                    exact
                                    path="/reserve-a-space"
                                    component={ReserveASpaceScreen}
                                />
                                <Route
                                    exact
                                    path="/"
                                    render={() => <Redirect to="/upcoming-bookings" />}
                                />
                                <Route
                                    render={props => (
                                        <NotFoundError {...props} homeDestination="/" />
                                    )}
                                />
                            </Switch>
                        </ErrorBoundary>
                    </Column>
                </Row>
            </Container>
            <Spacer height={3} />
            <Footer />
        </div>
    );
};

export default withPageTracking(Dashboard);
